// extracted by mini-css-extract-plugin
export default {"orange_button":"Header_orange_button__VrI2L","toolbar":"Header_toolbar__7GarJ"};